export const ValidationMethods =  {
  methods: {
  phoneNumberFormat: function() {
    var phone_val = this.phone_number;
    this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  },
  phoneNumberValidRegex: function() {
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  }
 }
}



// WEBPACK FOOTER //
// ./src/components/shared/common_validations.js